import { render, staticRenderFns } from "./backTop.vue?vue&type=template&id=027b4630"
import script from "./backTop.vue?vue&type=script&lang=js"
export * from "./backTop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports